import EditEmpCategory from "./Edit";

export default function AddEmpCategory() {
    return <EditEmpCategory mode="add" />;
}
